import { render, staticRenderFns } from "./MaterrialFileMain.vue?vue&type=template&id=008cb85a&scoped=true&"
import script from "./MaterrialFileMain.vue?vue&type=script&lang=js&"
export * from "./MaterrialFileMain.vue?vue&type=script&lang=js&"
import style0 from "./MaterrialFileMain.vue?vue&type=style&index=0&id=008cb85a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008cb85a",
  null
  
)

export default component.exports